import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface UserData {
	name: string;
	email: string;
	phone: string;
	role: string;
}

type LoginApiResponse = {
	user: UserData;
	token: string;
};

type InitialStateType = {
	isAuthenticated: boolean;
	token: string | null;
	user: UserData | null;
};

const initialState: InitialStateType = {
	isAuthenticated: false,
	token: null,
	user: null,
};

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setCredentials: (state, action: PayloadAction<LoginApiResponse>) => {
			const { token, user } = action.payload;
			state.isAuthenticated = action.payload !== null;
			state.token = token;
			state.user = user;
		},
		userLogout: (state) => {
			state.isAuthenticated = false;
			state.token = null;
			state.user = null;
		},
	},
});

export const { setCredentials, userLogout } = authSlice.actions;

export default authSlice.reducer;
